import { ChangeEvent, createContext, useContext } from 'react';
import type { FormWorker } from './form_manager/form_worker';

interface DynamicFormContextValue {
	formWorker: Readonly<FormWorker>;
	handleSubmit: (event: ChangeEvent<HTMLFormElement>) => void;
	handleGoBack: () => void;
}

export const DynamicFormContext = createContext<DynamicFormContextValue>(undefined as unknown as DynamicFormContextValue);

export function useDynamicFormContext(): DynamicFormContextValue {
	const context = useContext(DynamicFormContext);

	if (!context) {
		throw new Error("DynamicFormContext can't be used outside <DynamicForm.Root />");
	}

	return context;
}
